import React from 'react';
import { translations } from '../utils/translations.js';

const Footer = ({ isDarkMode, language }) => {
  const t = translations[language];
  return (
    <div>
      {/* Subtle divider line above footer */}
      <div className={`w-full h-px transition-colors duration-300 ${
        isDarkMode 
          ? 'bg-gradient-to-r from-transparent via-gray-600/30 to-transparent'
          : 'bg-gradient-to-r from-transparent via-gray-400/30 to-transparent'
      }`}></div>
        <footer className={`py-12 px-12 transition-colors duration-300 ${
        isDarkMode ? 'bg-gray-900' : 'bg-stone-200'
      }`}>
        <div className="max-w-6xl mx-auto">          {/* Mobile and tablet layout */}
          <div className="md:hidden flex items-start gap-12 pl-2">
            <div className="flex-shrink-0 -ml-4">
              <img 
                src={isDarkMode ? "/img/logo_darkmode.png" : "/img/logo_lightmode.png"}
                alt="ine"
                className="w-auto"
                style={{ height: '110px' }}
              />
            </div>
            <div className="flex-1 space-y-6 ml-4">
              <div>
                <h4 className={`font-semibold mb-4 transition-colors duration-300 ${
                  isDarkMode ? 'text-gray-200' : 'text-gray-900'
                }`}>
                  {t.location}
                </h4>
                <p className={`transition-colors duration-300 ${
                  isDarkMode ? 'text-gray-400' : 'text-gray-600'
                }`}>
                  {t.montevideo}
                </p>
              </div>
              <div>
                <h4 className={`font-semibold mb-4 transition-colors duration-300 ${
                  isDarkMode ? 'text-gray-200' : 'text-gray-900'
                }`}>
                  {t.contactInfo}
                </h4>
                <p className={`transition-colors duration-300 ${
                  isDarkMode ? 'text-gray-400' : 'text-gray-600'
                }`}>
                  inesvazlista@gmail.com
                </p>
                
              </div>
            </div>
          </div>
            {/* Desktop layout */}
          <div className="hidden md:grid grid-cols-3 gap-8">
            <div>
              <img 
                src={isDarkMode ? "/img/logo_darkmode.png" : "/img/logo_lightmode.png"}
                alt="ine"
                className="w-auto"
                style={{ height: '110px' }}
              />
            </div>
          <div>
            <h4 className={`font-semibold mb-4 transition-colors duration-300 ${
              isDarkMode ? 'text-gray-200' : 'text-gray-900'
            }`}>
              {t.location}
            </h4>
            <p className={`transition-colors duration-300 ${
              isDarkMode ? 'text-gray-400' : 'text-gray-600'
            }`}>
              {t.montevideo}
            </p>
          </div>
          <div>
            <h4 className={`font-semibold mb-4 transition-colors duration-300 ${
              isDarkMode ? 'text-gray-200' : 'text-gray-900'
            }`}>
              {t.contactInfo}
            </h4>
            <p className={`transition-colors duration-300 ${
              isDarkMode ? 'text-gray-400' : 'text-gray-600'
            }`}>
              inesvazlista@gmail.com
            </p>            <p className={`transition-colors duration-300 ${
              isDarkMode ? 'text-gray-400' : 'text-gray-600'
            }`}>
              
            </p>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default Footer;
